import React from "react";
import { ModalHeader, Modal } from "reactstrap";

const OnlineBiddingRegistrationModal = ({ isOpen, toggle }) => {
  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered
    >
      <ModalHeader toggle={() => toggle(!isOpen)}>Online Bidding Registration Required</ModalHeader>
      <p className="text-dark text-center p-3">
        <a href="/myaccount">Click Here </a> to request Online Bidding
        Privileges.
      </p>
    </Modal>
  );
};

export default OnlineBiddingRegistrationModal;
